import {
  faro,
  getWebInstrumentations,
  initializeFaro,
} from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import packageJson from "../package.json";
import type { UserOut } from "./api/types";

const collectorUrl = "/signals";
const eventDomain = "ensovia.beta";
let enabled = false;
let identifiedUserId: string | null = null;

if (import.meta.env.PROD) {
  initializeFaro({
    url: collectorUrl,
    app: {
      name: "ensovia-web",
      version: packageJson.version,
      environment: "production",
    },
    eventDomain,
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: false,
        enableContentSecurityPolicyInstrumentation: true,
      }),
      new TracingInstrumentation(),
    ],
    preventGlobalExposure: true,
    sessionTracking: {
      enabled: true,
      persistent: true,
      samplingRate: 1,
    },
  });
  enabled = true;
}

type AttributeValue = string | number | boolean | null | undefined;

export function trackEvent(
  name: string,
  attributes: Record<string, AttributeValue> = {},
) {
  if (!enabled) return;
  faro.api.pushEvent(
    name,
    Object.fromEntries(
      Object.entries(attributes)
        .filter(([, value]) => value !== null && value !== undefined)
        .map(([key, value]) => [key, String(value)]),
    ),
    eventDomain,
  );
}

export function identifyUser(user: UserOut) {
  if (!enabled) return;
  faro.api.setUser({
    id: user.id,
    email: user.email,
    fullName: user.name,
    roles: user.role,
  });
  if (identifiedUserId !== user.id) {
    identifiedUserId = user.id;
    trackEvent("user_identified", { role: user.role });
  }
}

export function clearUser() {
  if (!enabled) return;
  identifiedUserId = null;
  faro.api.resetUser();
}

export function trackPageView(pathname: string) {
  const match = pathname.match(
    /^\/docs\/([^/]+)(?:\/(package|wizard|report)(?:\/([^/]+))?)?$/,
  );
  const documentId = match?.[1];
  const section = match?.[2];
  const rowKey = match?.[3];
  const route = match
    ? `/docs/:document_id${section ? `/${section}` : ""}${rowKey ? "/:row_key" : ""}`
    : pathname;

  trackEvent("page_view", {
    route,
    document_id: documentId,
    row_key: rowKey,
  });
}
